module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape-area-821363b32f477e6a720a7874a365909b.jpg";